import {
  BulkApproveRemediationTrackerTaskDTO,
  BulkRejectRemediationTrackerTaskDTO,
  ParentChildApprovalRejectionDataDTO,
  RemediationTrackerTaskQuestionDTO,
  RemediationTrackerTaskSearchParameter,
  SearchParameterDTO,
} from "../../../common/types/common.dto.types";
import {
  MergeRemediationRequestDTO,
  RemediationTrackerTaskQuestionsRequestDTO,
} from "./RemediationTrackerTasksPage.types";

// ==============================|| VIEWS - PAGES - REMEDIATION TRACKER TASKS - ACTION ||============================== //

export const GETREMEDIATIONTRACKERTASKSLIST = "GETREMEDIATIONTRACKERTASKSLIST";
export const GETREMEDIATIONTRACKERTASKSDETAILS =
  "GETREMEDIATIONTRACKERTASKSDETAILS";
export const DELETEREMEDIATIONTRACKERTASK = "DELETEREMEDIATIONTRACKERTASK";
export const BULKAPPROVEREMEDIATIONTRACKERTASK =
  "BULKAPPROVEREMEDIATIONTRACKERTASK";
export const BULKREJECTREMEDIATIONTRACKERTASK =
  "BULKREJECTREMEDIATIONTRACKERTASK";
export const CHECKBULKAPPROVEREMEDIATIONTRACKERTASK =
  "CHECKBULKAPPROVEREMEDIATIONTRACKERTASK";
export const CHECKBULKREJECTREMEDIATIONTRACKERTASK =
  "CHECKBULKREJECTREMEDIATIONTRACKERTASK";

export const GETREMEDIATIONTRACKERTASINITIALDATA =
  "GETREMEDIATIONTRACKERTASINITIALDATA";

export const GETREMEDIATIONTRACKERTASKCOLUMNWISEFILTERLIST =
  "GETREMEDIATIONTRACKERTASKCOLUMNWISEFILTERLIST";

export const GETREMEDIATIONTRACKERTASKSTATUSSUMMARYFILTEREDLIST =
  "GETREMEDIATIONTRACKERTASKSTATUSSUMMARYFILTEREDLIST";

export const MERGEREMEDIATIONTRACKERTASKS = "MERGEREMEDIATIONTRACKERTASKS";
export const DELETEREMEDIATIONTRACKERTASKS = "DELETEREMEDIATIONTRACKERTASKS";
export const UNMERGEREMEDIATIONTRACKERTASKS = "UNMERGEREMEDIATIONTRACKERTASKS";
export const GETREMEDIATIONtASKQUESTIONDETAILS =
  "GETREMEDIATIONtASKqUESTIONDETAILS";

export const getRemediationTrackerTaskInitialData = () => {
  return {
    type: GETREMEDIATIONTRACKERTASINITIALDATA,
  };
};

export const getRemediationTrackerTaskList = (
  searchParameter: RemediationTrackerTaskSearchParameter
) => {
  return {
    type: GETREMEDIATIONTRACKERTASKSLIST,
    payload: {
      searchParameter: searchParameter,
    },
  };
};

export const getRemediationTrackerTaskDetails = (parentTaskId: number) => {
  return {
    type: GETREMEDIATIONTRACKERTASKSDETAILS,
    payload: parentTaskId,
  };
};

export const deleteRemediationTrackerTask = (taskId: number) => {
  return {
    type: DELETEREMEDIATIONTRACKERTASK,
    payload: taskId,
  };
};

export const mergeRemediationTrackerTask = (
  mergeRemediationRequest: MergeRemediationRequestDTO
) => {
  return {
    type: MERGEREMEDIATIONTRACKERTASKS,
    payload: mergeRemediationRequest,
  };
};

export const deleteRemediationTrackerTaskById = (
  remediationTrackerId: number
) => {
  return {
    type: DELETEREMEDIATIONTRACKERTASKS,
    payload: remediationTrackerId,
  };
};

export const unMergeRemediationTrackerTask = (remediationTrackerId: number) => {
  return {
    type: UNMERGEREMEDIATIONTRACKERTASKS,
    payload: remediationTrackerId,
  };
};

export const getRemediationRTrackerTaskQuestionDetails = (
  remediationTrackerTask: RemediationTrackerTaskQuestionsRequestDTO
) => {
  return {
    type: GETREMEDIATIONtASKQUESTIONDETAILS,
    payload: remediationTrackerTask,
  };
};

export const CheckBulkApproveRemediationTrackerTask = (
  ParentChildApprovalRejectionDataDTO: ParentChildApprovalRejectionDataDTO
) => {
  return {
    type: CHECKBULKAPPROVEREMEDIATIONTRACKERTASK,
    payload: ParentChildApprovalRejectionDataDTO,
  };
};

export const CheckBulkRejectRemediationTrackerTask = (
  ParentChildApprovalRejectionDataDTO: ParentChildApprovalRejectionDataDTO
) => {
  return {
    type: CHECKBULKREJECTREMEDIATIONTRACKERTASK,
    payload: ParentChildApprovalRejectionDataDTO,
  };
};

export const bulkApproveRemediationTrackerTask = (
  selectedRemediationTrackerTask: BulkApproveRemediationTrackerTaskDTO
) => {
  return {
    type: BULKAPPROVEREMEDIATIONTRACKERTASK,
    payload: selectedRemediationTrackerTask,
  };
};

export const bulkRejectRemediationTrackerTask = (
  selectedRemediationTrackerTask: BulkRejectRemediationTrackerTaskDTO
) => {
  return {
    type: BULKREJECTREMEDIATIONTRACKERTASK,
    payload: selectedRemediationTrackerTask,
  };
};
